module.exports = __webpack_public_path__ + "static/media/book10.55144e7e.jpg";